<template>
    <div class="main-down" v-if="down_time <= 10" @click="reloadTime">
        <div class="down_time">{{ down_time }} s</div>
        <div class="down_tips">后无操作自动返回首页</div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        props: {
            type: {
                default: 'birthday_index'
            }
        },
		computed: {
			...mapGetters(['birthdayMachineInfo', 'aiMachineInfo']),
		},
        data(){
            return {
                base_time: 0,
                down_time: 0,
                timer: null,
            }
        },
        created(){
            if(this.type == 'birthday_index'){
                this.base_time = this.birthdayMachineInfo.pay_time ? this.birthdayMachineInfo.pay_time : 40;
            }else{
                this.base_time = this.aiMachineInfo.pay_time ? this.aiMachineInfo.pay_time : 40;
            }
            this.down_time = this.base_time;
            this.downTimes()
        },
        mounted() {
            // 添加事件监听器
            window.addEventListener('click', this.reloadTime);
        },
        methods: {
            // 倒计时
            downTimes(){
                this.timer = setInterval(()=>{
                    if(this.down_time > 0){
                        this.down_time = this.down_time - 1;
                    }else{
                        this.$router.replace({name: this.type});
                    }
                }, 1000);
            },
            // 重置计时器
            reloadTime(){
                this.down_time =this.base_time;
            }
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer); // 清除定时器
            }
            // 移除事件监听器
            window.removeEventListener('click', this.handleClick);
        }
    }
</script>

<style lang="scss">
    .main-down {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: #FFFFFF;
        font-weight: bold;
        font-family: 'bangBang';
        .down_time {
            font-size: 2rem;
        }
        .down_tips {
            font-size: 1.5rem;
            margin-top: 0.3rem;
        }
    }
</style>